import inquiryDetailInfo from './components/inquiryDetailInfo.vue';
import inquiryDetailProduct from './components/inquiryDetailProduct.vue';
import { getInquiryDetail } from '@/services/order/inquiry';
export default {
  name: 'inquiryDetail',
  i18n: require('./i18n-inquiry'),
  components: {
    inquiryDetailInfo: inquiryDetailInfo,
    inquiryDetailProduct: inquiryDetailProduct
  },
  data: function data() {
    return {
      activeKey: '1'
    };
  },
  mounted: function mounted() {},
  methods: {}
};